"use client";
import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import {
  sans as zoram,
  lineHeight,
  fontSize14,
  fontWeightNormal,
  fontWeightSemiBold,
  fontWeightBold
} from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
const Container4 = styled.div`
  font-family: ${zoram};
  font-weight: ${({ $emphasized }) => $emphasized ? fontWeightSemiBold : fontWeightNormal};
  line-height: ${lineHeight};
  font-size: ${fontSize14};
  ${shared};
  & b,
  & strong {
    font-weight: ${fontWeightBold};
  }
`;
const Text4 = ({
  children,
  emphasized = false,
  renderAs = "div",
  ...props
}) => /* @__PURE__ */ jsx(Container4, { $emphasized: emphasized, as: renderAs, ...props, children });
Text4.displayName = "Text4";
var Text4_default = Text4;
export {
  Text4_default as default
};
